module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Serena Tucacas","short_name":"Serena","description":"Apartamento vacacional frente al mar en Tucacas, Venezuela","start_url":"/","background_color":"#fcf1d9","theme_color":"#926f5c","display":"standalone","icon":"static/img/logo-serena-blue-bg-circle.png","icon_options":{"purpose":"any maskable"},"legacy":true,"include_favicon":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"405fddb3e96fcd3f3c11e8fe1b1d16c0"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
